import { t } from 'i18next';
import ProfileAvatar from '../../my-page/components/ProfileAvatar';

interface Props {
  name: string;
  imagePath?: string | null;
  description?: string;
}

export default function PhotoCardFirstCaptorCard({ name, imagePath, description }: Props) {
  return (
    <div className="mt-[12px] border border-[rgba(255,255,255,0.60)] rounded-[12px] p-[16px] shadow-[0_0_3px_0_rgba(0,0,0,0.07),0_4px_16px_0_rgba(0,0,0,0.03)]">
      <div className="flex flex-row items-center">
        <ProfileAvatar widthAndHeight="34px" svgWidthAndHeight="34px" thumbnailUrl={imagePath} />
        <div className="flex flex-col items-start justify-center flex-grow pl-[12px] gap-[4px]">
          <div className="text-[14px] font-semibold leading-[17px] tracking-normal text-left text-text-main-lv2">
            {name}
          </div>
          <div className="text-[12px] font-normal leading-[14px] tracking-normal text-left text-text-main-lv3">
            {description}
          </div>
        </div>
        <div className="min-w-[73px] min-h-[21px] px-[7px] py-1 rounded-[30px] text-[11px] font-semibold leading-[13px] tracking-normal text-left self-center bg-surface-light dark:bg-surface-dark">
          {t('photoCardDetailPage.firstCaptorBadge')}
        </div>
      </div>
    </div>
  );
}
